import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconManager } from '@speeki/icons';

import { Card } from '@components/molecules/Card/Card';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { useGetServiceRedirect } from '@utils/hooks/useServiceRedirect';
import { useUserLogin } from '@utils/hooks/useUserLogin';

import { getPath } from '@services/RouteService/paths';

import { FormBottomElement } from '@domains/auth/molecules/FormBottomElement/FormBottomElement';
import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';
import { LoginForm } from '@domains/auth/organisms/LoginForm/LoginForm';

export const LoginPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { login, sessionProcessing } = useUserLogin();
    const { isSurveysRedirect } = useGetServiceRedirect();

    return (
        <ColumnsLayout>
            <Card testId="o9w1Aed">
                <Card.Title>{t('LOGIN')}</Card.Title>
                <Card.Description>
                    {t('NEW_LOGIN_DESCRIPTION')}
                </Card.Description>
                <LoginForm
                    bottomElement={
                        isSurveysRedirect ? (
                            <FormBottomElement
                                buttonText={t('CONTINUE_AS_A_GUEST')}
                                onSubmit={() =>
                                    navigate(
                                        getPath({
                                            path: '/auth/login/guest',
                                        }),
                                    )
                                }
                            />
                        ) : undefined
                    }
                    handleLoginSubmit={login}
                    loading={sessionProcessing}
                />
            </Card>
            <LoginBanner>
                <IconManager icon={'SvgInfo'} size={16} />
                <LoginBanner.Description>
                    {t('NEW_TO_SPEEKI')}{' '}
                    <LoginBanner.Link to={getPath({ path: '/auth/signup' })}>
                        {t('CREATE_SPEEKI_ACCOUNT')}!
                    </LoginBanner.Link>
                </LoginBanner.Description>
            </LoginBanner>
        </ColumnsLayout>
    );
};
